var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        {
          staticClass: "inquiry-modal",
          on: {
            click: function ($event) {
              if ($event.target !== $event.currentTarget) return null
              return _vm.closeModal.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h3", [_vm._v("询盘订单")]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "close-btn", on: { click: _vm.closeModal } },
                [_vm._v("×")]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "order-list" },
              _vm._l(_vm.paginatedOrders, function (order, index) {
                return _c("div", { key: index, staticClass: "order-item" }, [
                  _c("div", { staticClass: "order-field" }, [
                    _c("span", { staticClass: "field-label" }, [
                      _vm._v("商品名称："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "field-value ellipsis-3" }, [
                      _vm._v(_vm._s(order.commodityName)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "order-field" }, [
                    _c("span", { staticClass: "field-label" }, [
                      _vm._v("商品规格："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "field-value" }, [
                      _vm._v(_vm._s(order.specifications || "无")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "order-row" }, [
                    _c("div", { staticClass: "order-field half-width" }, [
                      _c("span", { staticClass: "field-label" }, [
                        _vm._v("购买数量："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "field-value" }, [
                        _vm._v(_vm._s(order.quantity)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "order-field half-width" }, [
                      _c("span", { staticClass: "field-label" }, [
                        _vm._v("单价："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "field-value" }, [
                        _vm._v(_vm._s(order.unitPrice)),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "order-row" }, [
                    _c("div", { staticClass: "order-field half-width" }, [
                      _c("span", { staticClass: "field-label" }, [
                        _vm._v("支付状态："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "field-value" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              order.status == 0
                                ? "未支付"
                                : order.status == 1
                                ? "已支付"
                                : order.status == 2
                                ? "已发货"
                                : "已完成"
                            ) +
                            "\n            "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "order-field half-width" }, [
                      _c("span", { staticClass: "field-label" }, [
                        _vm._v("总价："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "field-value" }, [
                        _vm._v(_vm._s(order.totalPrice)),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "order-field" }, [
                    _c("span", { staticClass: "field-label" }, [
                      _vm._v("回件商家邮箱："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "field-value" }, [
                      _vm._v(_vm._s(order.businessEmail)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "order-field" }, [
                    _c("span", { staticClass: "field-label" }, [
                      _vm._v("是否发送邮箱："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "field-value" }, [
                      _vm._v(_vm._s(order.isEmail ? "已发送" : "未发送")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "toggle-payment-btn",
                      on: {
                        click: function ($event) {
                          return _vm.togglePayment(order.id)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.showPaymentMap[order.id]
                              ? "收起收款方式"
                              : "展开收款方式"
                          ) +
                          "\n          "
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "arrow-icon",
                          class: { rotate: _vm.showPaymentMap[order.id] },
                        },
                        [_vm._v("▼")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showPaymentMap[order.id],
                          expression: "showPaymentMap[order.id]",
                        },
                      ],
                      staticClass: "payment-method",
                    },
                    [
                      _c("h4", [_vm._v("收款方式")]),
                      _vm._v(" "),
                      order.collectionType === 2
                        ? _c("div", { staticClass: "bank-info" }, [
                            _c("div", { staticClass: "payment-field" }, [
                              _c("span", { staticClass: "field-label" }, [
                                _vm._v("受益人姓名："),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "field-value" }, [
                                _vm._v(_vm._s(order.beneficiaryName)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "payment-field" }, [
                              _c("span", { staticClass: "field-label" }, [
                                _vm._v("受益人地址："),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "field-value" }, [
                                _vm._v(_vm._s(order.beneficiaryAddress)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "payment-field" }, [
                              _c("span", { staticClass: "field-label" }, [
                                _vm._v("受益人账号："),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "field-value" }, [
                                _vm._v(_vm._s(order.beneficiaryAccNo)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "payment-field" }, [
                              _c("span", { staticClass: "field-label" }, [
                                _vm._v("银行地址："),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "field-value" }, [
                                _vm._v(_vm._s(order.addressOfBank)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "payment-field" }, [
                              _c("span", { staticClass: "field-label" }, [
                                _vm._v("SWIFT码："),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "field-value" }, [
                                _vm._v(_vm._s(order.swiftCode)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "payment-field" }, [
                              _c("span", { staticClass: "field-label" }, [
                                _vm._v("邮政编码："),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "field-value" }, [
                                _vm._v(_vm._s(order.postCode)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "payment-field" }, [
                              _c("span", { staticClass: "field-label" }, [
                                _vm._v("电话："),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "field-value" }, [
                                _vm._v(_vm._s(order.tel)),
                              ]),
                            ]),
                            _vm._v(" "),
                            order.customDefinition
                              ? _c("div", { staticClass: "payment-field" }, [
                                  _c("span", { staticClass: "field-label" }, [
                                    _vm._v("自定义字段："),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "field-value" }, [
                                    _vm._v(_vm._s(order.customDefinition)),
                                  ]),
                                ])
                              : _vm._e(),
                          ])
                        : order.collectionType === 1
                        ? _c("div", { staticClass: "qrcode-info" }, [
                            _c(
                              "div",
                              { staticClass: "qrcode-image-container" },
                              [
                                _c("img", {
                                  staticClass: "qrcode-image",
                                  attrs: {
                                    src: order.collectionQrcode,
                                    alt: "收款码",
                                  },
                                }),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ])
              }),
              0
            ),
            _vm._v(" "),
            _vm.orderData.length > _vm.itemsPerPage
              ? _c("div", { staticClass: "pagination" }, [
                  _c(
                    "button",
                    {
                      staticClass: "page-btn",
                      attrs: { disabled: _vm.currentPage === 1 },
                      on: { click: _vm.prevPage },
                    },
                    [_vm._v("\n        上一页\n      ")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "page-info" }, [
                    _vm._v(
                      "\n        第 " +
                        _vm._s(_vm.currentPage) +
                        " 页 / 共 " +
                        _vm._s(_vm.totalPages) +
                        " 页\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "page-btn",
                      attrs: { disabled: _vm.currentPage === _vm.totalPages },
                      on: { click: _vm.nextPage },
                    },
                    [_vm._v("\n        下一页\n      ")]
                  ),
                ])
              : _vm._e(),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }